import { render, staticRenderFns } from "./Util-Item-Sparepart.vue?vue&type=template&id=61c981c4"
import script from "./Util-Item-Sparepart.vue?vue&type=script&lang=js"
export * from "./Util-Item-Sparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports